// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1B2-1","footer":"ChangeClinic_footer__3DGoq"};